import React from 'react';
import TableCell from "@material-ui/core/TableCell"; // Asegúrate de que el paquete esté instalado

const CustomTableHead = (props) => {
    return (
        <TableCell
            style={{ backgroundColor: '#f5f5f5', color: 'black', fontSize: 10 ,fontFamily: 'Montserrat',paddingLeft:'3px'}}
            {...props}
        />
    );
};

export default CustomTableHead;